function listenerGlobalEvents(type, selector, callback) {
  document.addEventListener("click", (e) => {
    if (e.target.matches(selector)) callback(e);
  });
}

//all add-to-cart handler
// var product_id_added = '34';
// var showzero = 0 ;

function emptycarttrue(work) {
  if (work === "add") {
    document
      .querySelector(".prpwebs-popup-cart-load")
      .classList.add("emptycarttrue");
    document
      .querySelector(".prpwebs-drawer-checkout")
      .classList.add("emptycarttrue");
    document.querySelector(".prpwebs-empty-cart").style.display = "block";
  } else if (work === "remove") {
    document
      .querySelector(".prpwebs-popup-cart-load")
      .classList.remove("emptycarttrue");
    document
      .querySelector(".prpwebs-drawer-checkout")
      .classList.remove("emptycarttrue");
    document.querySelector(".prpwebs-empty-cart").style.display = "none";
  } else {
    return;
  }
}

//get cart items for cart drawer
async function getCartProducts() {
  // loader image show and remove on cart drawer
  const loaderImg = document.querySelector(".cart_loader_img");
  loaderImg ? loaderImg.classList.add("active") : "";

  let cartHtml = "";

  // remove emptycarttrue class on cart drawer app
  emptycarttrue("remove");

  // api call and create html
  await fetch("/cart.js", { method: "GET" })
    .then((response) => response.json())
    .then((cart) => {
      // now have access to Shopify cart object
      let carp_url = "";
      let carp_fImage = "";
      let carp_title = "";
      let carp_vtitle = "";
      let carp_itemId = "";
      let carp_itemVid = "";
      let carp_quantity = "";
      let carp_orginalPrice = "";
      let carp_finalPrice = "";
      let cartitems = cart.items;
      let itemindex = 0;

      document.querySelector(".cart-count-js").innerHTML = cart.item_count;

      for (let key in cartitems) {
        itemindex = itemindex + 1;
        let item = cartitems[key];
        let itemID = key + 1;
        carp_url = item.url;
        carp_fImage = item.image;
        carp_title = item.product_title;
        carp_itemId = item.id;
        carp_itemVid = item.variant_id;
        carp_quantity = item.quantity;
        carp_orginalPrice = item.price;
        carp_orginalPrice = carp_orginalPrice / 100;
        carp_orginalPrice = carp_orginalPrice.toFixed(2);
        carp_finalPrice = item.final_price;
        carp_finalPrice = carp_finalPrice / 100;
        carp_finalPrice = carp_finalPrice.toFixed(2);
        //console.log(item.variant_title);
        if (item.variant_title === null) {
          //console.log('hello from null');
          carp_vtitle = " ";
        } else {
          if (item.variant_title != "Default Title") {
            carp_vtitle = item.variant_title;
          } else {
            carp_vtitle = " ";
          }
        }

        let prpwebs_quantity = `<div class="prpwebs-item-cart-qty prpwebs-item-${carp_itemId} quantity center">
                              <div class="js-qty__adjust_prpwebs1 prpwebs-cart-plus-minus" data-quantity="${carp_quantity}" data-id="${carp_itemId}" data-line="1">
                                  <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                                      <span class="prpwebs-minus-symbol" id="minus-${itemindex}" onclick=minusItem(event,${itemindex},${carp_itemId})>-</span>
                                  </div>
                                   <label for="inputQuantity_${itemindex}" class="visually-hidden">Quantity</label>
                                  <input type="text" value="${carp_quantity}" class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox" data-id="${carp_itemId}" id="inputQuantity_${itemindex}" disabled>

                                 <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                                      <span class="prpwebs-plus-symbol" id="plus-${itemindex}" onclick=plusItem(event,${itemindex},${carp_itemId})>+</span>
                                </div>
                              </div>  
                          </div>`;
        console.log(
          `${parseFloat(carp_orginalPrice)} > ${parseFloat(carp_finalPrice)}`
        );
        if (parseFloat(carp_orginalPrice) > parseFloat(carp_finalPrice)) {
          var amount_real =
            "<del>$" +
            (carp_orginalPrice * carp_quantity * 1).toFixed(2) +
            "</del> $" +
            (carp_finalPrice * carp_quantity * 1).toFixed(2);
          //console.log(amount_real);
        } else {
          var amount_real =
            "$" + (carp_orginalPrice * carp_quantity * 1).toFixed(2);
        }
        cartHtml +=
          `     
          <div class="prpwebs-item-cart-content" id="item-${itemindex}">
                  <div class="prpwebs-item-content-variants">
                       <div class="prpwebs-item-cart-image">
                              <a href="${carp_url}"><img class="prpwebs-cart-image" src="${carp_fImage}"  alt="${carp_title}"/></a>
                      </div> 
                <div class="prpwebs-item-cart-description">
                  <div class="prpwebs-item-close">
                      <a href="javascript:void(0);" class="prpwebs-remove-item" data-id="${carp_itemId}" aria-label="Remove item" onclick="removItemCart(${carp_itemId},'item-${itemindex}')">
                          <span class="prpwebs-close-btn">&times;</span>
                      </a>
                  </div>  
                <div class="prpwebs-content-product-and-variant-title">  
                      <a href="${carp_url}" class="prpwebs-product-title gt_america_bold">  ${carp_title}  </a>  
          <span class="prpwebs-variant-title gt_america">${carp_vtitle}</span>  
                      <div class="prpwebs-propertie-content"></div>  
                </div> 
                <div class="prpwebs-content-quantity-price">

                      <div class="prpwebs-item-cart-content-quantity">  
						
                          ${prpwebs_quantity}

                      </div>

                      <div class="prpwebs-cart-content-price cartitem-id-${carp_itemId}">  
                            <span class="prpwebs-compare-at-price"></span>
                            <span class="prpwebs-price-total gt_america_bold prpwebs-desktop"> 
							<span class="money" id="inputPrice_${itemindex}" data-current_price="${item.final_price}" data-main_price="${item.price}">` +
          amount_real +
          `</span></span>      
                      </div>
                </div>
                </div>
                </div>
                </div> `;
      }
    })
    .finally(function () {
      // remove load img
      const loaderImgRemove = document.querySelector(".cart_loader_img");
      loaderImgRemove ? loaderImgRemove.classList.remove("active") : "";

      //  update cart items on cart drawer and open drawer
      document.querySelector(".prpwebs_cartitems").innerHTML = cartHtml;
      document
        .querySelector(".prpwebs-popup-drawer-load")
        .classList.add("active");
    });
}

// on click on pw-btn class element on all type of pages ( collection, product and other pages
const pw_btn = document.querySelector("body");
pw_btn.addEventListener("click", async function (e) {
  const pwBtnCurrent = e.target.closest('form[action="/cart/add"] .pw-btn');
  if (pwBtnCurrent) {
    let btnText = pwBtnCurrent.querySelector(".atc-btn-text").innerHTML;

    //   	 adding process and show message on button
    pwBtnCurrent.querySelector(".atc-btn-text").innerHTML = "adding...";

    // add class on current click
    pwBtnCurrent.classList.add("current_add");

    let productID = "";
    form_array = [...pwBtnCurrent.closest("form").querySelectorAll("input")];

    // get product variant id on product page and other page.
    if (window.templateName.includes("product")) {
      var quantity = pwBtnCurrent
        .closest("form")
        .querySelector(".quantity__input").value;
      let pid = form_array.find((item) => item.name === "id");
      productID = pid["value"];
    } else {
      productID = form_array[0].value;
    }

    // product quantity and product variants id for product page and other pages.
    if (quantity == undefined) {
      quantity = 1;
    }

    //  /cart/add.js api call for adding product in cart
    let formData = {
      items: [
        {
          quantity: quantity,
          id: productID,
        },
      ],
    };

    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong. Please try again");
      })
      .then(async (data) => {
        let lodinghr = document.querySelector(".loadinghr");
        lodinghr.style.display = "block";

        await getCartProducts();
        pwBtnCurrent.querySelector(".atc-btn-text").innerHTML = "Add To Cart";
        changeValues();

        document
          .querySelector(".prpwebs-popup-drawer-load")
          .classList.add("active");
        document.querySelector("body").classList.add("prpwebs-cart-open");
      })
      .catch((error) => {
        alert(error);
        pwBtnCurrent.querySelector(".atc-btn-text").innerHTML = "Add To Cart";
      });
  }
});

//get cart items for cart drawer function
const checkCart = async function () {
  const response = await fetch("/cart.js", { method: "GET" });
  const data = await response.json();

  if (data.items.length == 0) {
    emptycarttrue("add");
  } else {
    emptycarttrue("remove");
  }
};

// // call function to update cart drawer based on item
checkCart();

//change subtotal prices
async function changeValues() {
  await fetch("/cart.js", { method: "GET" })
    .then((response) => response.json())
    .then((data) => {
      if (window.cartDrawerDynamicUpsell) {
        createupsellItem(data);
      }
      let total_cart = data.total_price / 100;
      total_cart = total_cart.toFixed(2);
      document.querySelector(".cart__subtotal").innerHTML = `$${total_cart}`;
      document.querySelector(".cart-count-js").innerHTML = data.item_count;
      //  show message of free shipping above $49
      if (data.total_price < 4900) {
        //                 console.log("hhhh less 49");
        let ship_amt = (4900 - data.total_price) / 100;
        ship_amt = ship_amt.toFixed(2);

        document.querySelector(
          ".shipping_count_div #shipping_count_data"
        ).innerHTML = `YOU ARE <span class="shipamount gt_america_bold">$${ship_amt}</span> AWAY FROM FREE SHIPPING`;
        document
          .querySelector(".shipping_count_div #cartprogressbar")
          .setAttribute("value", data.total_price / 100);
      } else {
        //               console.log("hhhh greater 49");
        document.querySelector(
          ".shipping_count_div #shipping_count_data"
        ).innerHTML = `YOUR BAG QUALIFIES FOR FREE SHIPPING`;
        document
          .querySelector(".shipping_count_div #cartprogressbar")
          .setAttribute("value", data.total_price / 100);
      }

      if (data.total_price < data.original_total_price) {
        document.querySelector(
          ".prpwebs-amount-sub-total .money-original"
        ).innerHTML = Shopify.formatMoney(data.original_total_price);
      }
    });
}

//check cart items in upsell
function checkItemInUpsell(data) {
  let items = data.items;
  let currentUpsellItems = localStorage.getItem("currentUpsellItems");
  let suggestionsarray = (currentUpsellItems || "").split("|");

  //all handles
  let extraUpsellItems = localStorage.getItem("productHandles");
  extraUpsellItems = (extraUpsellItems || "").replace(/['"]+/g, "");
  extraUpsellItems = extraUpsellItems.split("|");

  suggestionsarray = suggestionsarray.concat(extraUpsellItems);
  suggestionsarray = suggestionsarray.filter(
    (v, i) => suggestionsarray.indexOf(v) == i
  );

  let uniquesuggestion = [];
  let count = 1;

  for (let itemdata in items) {
    let item = items[itemdata];

    if (suggestionsarray.includes(item.handle)) {
      let index = suggestionsarray.indexOf(item.handle);
      if (index > -1) {
        suggestionsarray.splice(index, 1);
      }
    }

    if (items.length == count) {
      localStorage.setItem("allsuggestions", JSON.stringify(suggestionsarray));
      return true;
    }
    count = count + 1;
  }

  return true;
}

//upsell item insert after add to cart
function insertupsellItems() {
  let upsellhtml = localStorage.getItem("upsellItemHtml");
  let lodinghr = document.querySelector(".loadinghr");
  if (lodinghr) lodinghr.style.display = "none";

  if (upsellhtml != "" && upsellhtml != null) {
    let container = document.querySelector(".prpwebs-recommendations-data");
    if (container) container.innerHTML = upsellhtml;
  } else {
    let emptyBought = document.querySelector(".empty-bought-together");
    if (emptyBought) {
      let autoRecomm = emptyBought.innerHTML;
      let container = document.querySelector(".prpwebs-recommendations-data");
      if (container) container.innerHTML = autoRecomm;
    }
  }
  initDragToScroll();
  setTimeout(function () {
    if (typeof window.StampedFn !== "undefined") {
      if (typeof window.StampedFn.loadBadges === "function") {
        window.StampedFn.loadBadges();
      } else if (typeof window.StampedFn.reloadUGC === "function") {
        window.StampedFn.reloadUGC();
      }
    }
  }, 100);
}

function initDragToScroll() {
  const slider = document.querySelector('.prpwebs-recommendations-data');
  if (!slider || slider.dataset.dragInitialized) return;
  slider.dataset.dragInitialized = "true";

  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;
    slider.classList.add('is-dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('is-dragging');
    setTimeout(() => { isDragging = false; }, 50);
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    if (Math.abs(walk) > 5) {
      isDragging = true;
    }
    slider.scrollLeft = scrollLeft - walk;
  });

  slider.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}

document.addEventListener("DOMContentLoaded", function() {
  initDragToScroll();
});
window.addEventListener("load", function() {
  initDragToScroll();
});

// Sample Product select function
// function sample_product() {
//   var one = "39393805238361";
//   var swatch_selected_1 = "";
//   var sampleOne = document.querySelectorAll(
//     ".prpwebs-variants-swipper .product-type-swatches__list.sample-1 .shade-swatch"
//   );

//   Array.from(sampleOne).forEach((link) => {
//     link.addEventListener("click", function () {
//       one = this.getAttribute("data-product-id");
//       swatch_selected_1 = this.getAttribute("data-product-title");
//       document.querySelector(".sample_select_1").textContent =
//         swatch_selected_1;
//       document
//         .querySelector(".sample_add_button")
//         .setAttribute("data-product-id", one);
//       $(this)
//         .addClass("is-selected")
//         .siblings(".sample-1 .shade-swatch")
//         .removeClass("is-selected");
//       console.log(one);
//     });
//   });
// }

// sample_product();

function loadStaticUpsellFallback() {
  let staticHtml = localStorage.getItem("staticUpsellHtml");
  if (staticHtml) {
    try {
      staticHtml = JSON.parse(staticHtml);
    } catch (e) {}
    if (staticHtml && staticHtml.trim() !== "") {
      localStorage.setItem("upsellItemHtml", staticHtml);
      setTimeout(function () {
        insertupsellItems();
      }, 200);
    }
  }
}

function jsonCallShopify(suggestions, index, counterForCart, upsellHtml, type) {
  if (!suggestions || index >= suggestions.length || counterForCart > 3) {
    if (upsellHtml && upsellHtml.trim() !== "") {
      localStorage.setItem("upsellItemHtml", upsellHtml);
      setTimeout(function () {
        insertupsellItems();
      }, 200);
    } else if (counterForCart === 1) {
      loadStaticUpsellFallback();
    }
    return;
  }

  var itemSelected = suggestions[index];
  var selvariantid = 0;

  if (itemSelected && itemSelected.includes(":")) {
    let handle_with_variants = itemSelected.split(":");
    itemSelected = handle_with_variants[0];
    type = "variant";
    selvariantid = handle_with_variants[1];
  }

  if (itemSelected) {
    fetch(`/products/${itemSelected}.js`, { method: "GET" })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Product fetch failed");
        }
        return response.json();
      })
      .then((item) => {
        if (item && item.available) {
          let carp_url = item.url;
          let carp_fImage = item.featured_image;
          let carp_title = item.title;
          let carp_vtitle = item.variants[0] ? item.variants[0].name : "";
          let carp_itemId = item.id;
          let carp_itemVid = item.variants[0] ? item.variants[0].id : "";
          let carp_orginalPrice = Shopify.formatMoney(item.price);

          let filtervariants = item.variants.filter((data) => {
            return data.id == selvariantid;
          });

          if (type == "variant" && filtervariants && filtervariants.length > 0) {
            filtervariants = filtervariants[0];
            carp_title = item.title;
            carp_vtitle = filtervariants.title;
            carp_itemVid = filtervariants.id;
            carp_orginalPrice = Shopify.formatMoney(filtervariants.price);
            if (filtervariants.featured_media && filtervariants.featured_media.preview_image) {
              carp_fImage = filtervariants.featured_media.preview_image.src;
            }
          }

          let vTitleHtml = carp_vtitle && carp_vtitle.toLowerCase() !== "default title" ? `<span class="prpwebs-variant-title">${carp_vtitle}</span>` : "";

          upsellHtml += `
            <div class="prpwebs-products-dynamic-stacked">
              <div class="prpwebs-swiper-slide">
                <div class="prpwebs-content-product-slide-cart">
                  <div class="prpwebs-product-content-image-swipper">
                    <a href="${carp_url}?variant=${carp_itemVid}">
                      <img class="prpwebs-cart-image" src="${carp_fImage}" alt="${carp_title}" />
                    </a>
                  </div>
                  <div class="prpwebs-content-title-price-swiper">
                    <div class="prpwebs-title-swiper">
                      <a href="${carp_url}?variant=${carp_itemVid}" class="prpwebs-product-title">${carp_title}</a>  
                      ${vTitleHtml}
                    </div>
                    <span
                      class="stamped-product-reviews-badge"
                      data-id="${carp_itemId}"
                      data-product-sku="${item.handle || itemSelected}"
                      data-product-type="${item.type || ''}"
                      data-product-title="${carp_title.replace(/"/g, '&quot;')}"
                      style="display:block; text-align:left;"
                    ></span>
                    <div class="prpwebs-content-price-swiper">
                      <div class="prpwebs-price-sw">
                        <span class="money">${carp_orginalPrice}</span>
                      </div>
                    </div>
                    <div class="add-upsell-items upsell-cart">
                      <div class="prpwebs-variants-swipper">
                        <div class="prpwebs-qty-upsell">
                          <div class="prpwebs-item-cart-content-quantity">  
                            <div class="prpwebs-item-cart-qty prpwebs-item-${carp_itemId} quantity center">
                              <div class="js-qty__adjust1 prpwebs-cart-plus-minus" data-quantity="1" data-id="${carp_itemVid}">
                                <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                                  <span class="prpwebs-minus-symbol">-</span>
                                </div>
                                <label for="updates_${carp_itemVid}" class="visually-hidden">Quantity</label>
                                <input type="text" value="1" class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox" data-id="${carp_itemVid}" id="updates_${carp_itemVid}" name="quantity" readonly style="background:#fff;">
                                <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                                  <span class="prpwebs-plus-symbol">+</span>
                                </div>
                              </div>  
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="prpwebs-upsell-add">
                        <button type="button" name="id" class="prpwebs-upsell-add-to-cart prpwebs-button-background-color btn" data-product-id="${carp_itemVid}">
                          <span class="prpwebs-add--to--cart">ADD</span>
                          <span class="prpwebs--loading">
                            <i class="fa fa-circle-o fa-spin fa-1x fa-fw margin-bottom"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>`;
          counterForCart++;
        }
        jsonCallShopify(suggestions, index + 1, counterForCart, upsellHtml, type);
      })
      .catch((err) => {
        jsonCallShopify(suggestions, index + 1, counterForCart, upsellHtml, type);
      });
  } else {
    jsonCallShopify(suggestions, index + 1, counterForCart, upsellHtml, type);
  }
}

//upsell item create after add to cart
function createupsellItem(cartitems) {
  if (!window.cartDrawerDynamicUpsell) return;
  let rawUpsellItems = localStorage.getItem("UpsellItems");
  if (!rawUpsellItems) {
    loadStaticUpsellFallback();
    return;
  }
  let upsellItems;
  try {
    upsellItems = JSON.parse(rawUpsellItems);
  } catch (e) {
    loadStaticUpsellFallback();
    return;
  }
  if (!upsellItems || !upsellItems.upsellItems) {
    loadStaticUpsellFallback();
    return;
  }
  upsellItems = upsellItems.upsellItems;

  let item = cartitems != undefined && cartitems.items ? cartitems.items[0] : null;
  if (item != null && upsellItems.hasOwnProperty(item.handle)) {
    let itemHandle = item.handle;
    let filteritems = filterupsellitems(upsellItems, itemHandle, item.variant_id);
    if (filteritems && filteritems[itemHandle]) {
      if (filteritems[itemHandle].variants) {
        let productVariants = filteritems[itemHandle].variants;
        let VariantObject = productVariants[item.variant_id];
        if (VariantObject && VariantObject.suggestions) {
          suggestionString(VariantObject, cartitems?.items, "variant");
        } else {
          let ProductObject = filteritems[itemHandle];
          if (ProductObject && ProductObject.suggestions) {
            suggestionString(ProductObject, cartitems?.items, "product");
          } else {
            loadStaticUpsellFallback();
          }
        }
      } else {
        let ProductObject = filteritems[itemHandle];
        if (ProductObject && ProductObject.suggestions) {
          suggestionString(ProductObject, cartitems?.items, "product");
        } else {
          loadStaticUpsellFallback();
        }
      }
    } else {
      loadStaticUpsellFallback();
    }
  } else {
    loadStaticUpsellFallback();
  }
}

//upsell item filters
function filterupsellitems(object, data, vid) {
  const allowed = [data];
  const filtered = Object.keys(object)
    .filter((key) => allowed.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key];
      return obj;
    }, {});
  return filtered;
}

function suggestionString(SuggestionData, cartitemdata, type) {
  let suggestionString = SuggestionData ? SuggestionData.suggestions : "";
  let suggestions = (suggestionString || "").split("|").filter((s) => s && s.trim() !== "");
  localStorage.setItem("currentUpsellItems", suggestionString || "");

  //all handles
  let extraUpsellItems = localStorage.getItem("productHandles");
  extraUpsellItems = (extraUpsellItems || "").replace(/['"]+/g, "");
  extraUpsellItems = extraUpsellItems ? extraUpsellItems.split("|").filter((s) => s && s.trim() !== "") : [];

  let allsuggestionsarray = suggestions.concat(extraUpsellItems);
  let newsuggestions = allsuggestionsarray.filter(
    (v, i, a) => a.indexOf(v) === i && v.trim() !== ""
  );

  // If length of suggestions is less than 1, fallback to static upsells
  if (!newsuggestions || newsuggestions.length < 1) {
    loadStaticUpsellFallback();
    return;
  }

  localStorage.setItem("upsellItemHtml", " ");
  jsonCallShopify(newsuggestions, 0, 1, "", type);
}
